import React, { useState, useEffect, useContext } from "react";
import { useFormik } from 'formik';
import Select from 'react-select';
import { components } from 'react-select';
import * as Yup from 'yup';
import { realizarDonacion, getProjects } from '../../services/services';
import style from '../index.module.css'
import { styleSelect, styleSelectWithValue } from "../constants/select-style";
import ThankYouAlert from "../thank-modal/thank-modal";
import GlobalContext from "../../context/formContext";


/**
 * 
 * Formulario de donaciones puntuales
 */
export default function PartnerForm() {
  const { config, urlBase } = useContext(GlobalContext);

  const [documentSelectedValue, setDocumentSelectedValue] = useState(false);
  const [fileNameSelected, setfileNameSelected] = useState('Copia del pasaporte*');
  const [fileNameTrans, setFileNameTrans] = useState('Comprobante transferencia*');
  const [typeProjectOption, setTypeProject] = useState(undefined);
  const [selectedOption, setSelectedOption] = useState(undefined);
  const [amountForDonation, setamountForDonation] = useState(20);
  const [showHiddeOther, setShowHiddeOther] = useState(true);
  const [labelClickSelected, setLabelClickSelected] = useState(undefined);
  const [showProjectTypeError, setShowProjectTypeError] = useState(false);
  const [showDocumentTypeError, setShowDocumentTypeError] = useState(false);
  const [typeProjectSelectOption, setTypeProjectSelectOption] = useState([]);
  const [clickOnSubmit, setClickOnSubmit] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);
  const [error, setError] = useState();
  const [passportFile, setPassportFile] = useState([]);
  const [transferFile, setTransferFile] = useState([]);
  const [loading, setloading] = useState(false);
  const [policePrivacity, setPolicePrivacity] = useState(false);
  const [showPolicePrivacityError, setShowPolicePrivacityError] =
    useState(false);

  const documentsOptions = [
    //{ value: 0, label: 'Seleciona el tipo de documento*' },
    { value: 0, label: 'DNI/NIE' },
    { value: 1, label: 'CIF' },
    { value: 2, label: 'Pasaporte' }
  ];

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      firstName: '',
      projectId: undefined,
      documentIdType: undefined,
      documentNumber: '',
      prefix: '',
      address: '',
      province: '',
      country: '',
      email: '',
      phone: '',
      transferChecked: '',
      passportCopy: '',
      otherQuantity: 20,
      //terms: false,
    },
    validationSchema: Yup.object({
      firstName: Yup.string().matches(/^(?=.*[a-zA-Z]).+$/, 'Debe contener caracteres').required('Campo requerido'),
      documentIdType: Yup.number().notOneOf([undefined], 'Campo requerido').required('Campo requerido'),
      projectId: Yup.string().notOneOf([undefined], 'Campo requerido').required('Campo requerido'),
      documentNumber: Yup.string().matches(/^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9]{8,10}$/, 'Número de documento no válido').required('Campo requerido'),
      otherQuantity: Yup.number().required('Campo requerido').positive('Debe ser un número positivo').integer('Debe ser un número entero mayor que cero'),
      address: Yup.string().matches(/^[a-zA-ÄÖÜäöüßÀÁÈÉÌÍÒÓÙÚàáèéìíòóùúÂÊÎÔÛâêîôûÃÕÑãõñËÏÙëïüºª\s\u00f1\u00d1\u0020-\u007E]{5,}$/, 'Dirección no válida').min(5, 'Dirección no válida').required('Campo requerido'),
      province: Yup.string().matches(/^[A-Za-ÄÖÜäöüßÀÁÈÉÌÍÒÓÙÚàáèéìíòóùúÂÊÎÔÛâêîôûÃÕÑãõñËÏÙëïü\s\u00f1\u00d1\u0020-\u007E]+$/, 'Solo puede contener caracteres').required('Campo requerido'),
      country: Yup.string().matches(/^[a-zA-ÄÖÜäöüßÀÁÈÉÌÍÒÓÙÚàáèéìíòóùúÂÊÎÔÛâêîôûÃÕÑãõñËÏÙëïü\s\u00f1\u00d1]+$/, 'Solo puede contener caracteres').min(4, 'Debe tener al menos 4 caracteres').required('Campo requerido'),
      email: Yup.string().email('Formato de email inválido').required('Campo requerido'),
      phone: Yup.string().matches(/^\+?[0-9]+$/, 'Solo puede contener dígitos').min(9, 'Teléfono con formato incorrecto (9 dígitos)').required('Campo requerido'),
      transferChecked: Yup.string().required('Campo requerido'),
      //terms: Yup.boolean().oneOf([true], 'Debes aceptar los términos y condiciones')
    }),
    onSubmit: async (values, { resetForm }) => {
      if (policePrivacity === false) {
        setShowPolicePrivacityError(true);
        return false;
      } else {
        setShowPolicePrivacityError(false);
      }
      setShowProjectTypeError(false);
      setShowDocumentTypeError(false);
      setloading(true)
      const response = await enviarDonacion(values);
      //const response = {status:200};
      setloading(false)
      if (response.errors) {
        const error = response.errors.toString()
        switch (error) {
          case '400':
            setError('Los datos introducidos son incorrectos.')
            break;
          case '429':
            setError('Gracias por tu donación. Para realizar otra, debe esperar unos minutos.')
            break;
          default:
            setError('Ha ocurrido un error, vuelva a intentarlo.')
            break;
        }
      }

      if (response !== false && response !== undefined && !response.errors) {
        setShowThankYou(true)
        setFileNameTrans('Comprobante transferencia*');
        setfileNameSelected('Copia del pasaporte*');
        formik.setFieldValue('documentIdType', undefined);
        formik.setFieldValue('projectId', undefined);
        setamountForDonation(20)
        setTypeProject(undefined);
        setSelectedOption(undefined);
        setPolicePrivacity(false);
        setShowPolicePrivacityError(false);
        setTransferFile([]);
        setPassportFile([]);
        setError();
        resetForm();
      } else {
        //setError(<p>Ha ocurrido un error, vuelva a intentarlo.</p>);
        setTimeout(() => {
          setError();
        }, 5000);
      }
    },
  });

  useEffect(() => {
    donateFuncion();
  }, [amountForDonation]);

  useEffect(() => {
    if (config.projects) _handleGetAllProject(config.projects);
  }, [config.projects]);

  useEffect(() => {
    triggerChangeRadio();
  }, [labelClickSelected]);

  useEffect(() => {
    triggerProyectChangeRadio();
  }, [typeProjectOption]);

  function triggerChangeRadio() {
    setSelectedOption(labelClickSelected);
    formik.setFieldValue('documentIdType', labelClickSelected);
    formik.setFieldValue('passportCopy', '');
    if (labelClickSelected === 2) setDocumentSelectedValue(true);
    else setDocumentSelectedValue(false);
  }
  function triggerProyectChangeRadio() {
    setTypeProject(typeProjectOption);
    formik.setFieldValue('projectId', typeProjectOption);
  }
  const _handleGetAllProject = async (result) => {
    const oneProjectSelectOption = result.map(objeto => {
      return {
        value: objeto.id,
        label: objeto.name
      };
    });
    setTypeProjectSelectOption(oneProjectSelectOption)
  };

  function donateFuncion() {
    if (amountForDonation === 0) {
      formik.setFieldValue('otherQuantity', '');
      setShowHiddeOther(false)
    } else {
      formik.setFieldValue('otherQuantity', amountForDonation);
      setShowHiddeOther(true)
    }
  }

  const handleSelectingFile = (event) => {
    formik.handleChange(event);
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = () => {
      const base64String = reader.result;
      //console.log(base64String);
      const ext = file.type.split('/');
      setPassportFile({ name: file.name, extension: ext[1], base64: base64String })
    };
    reader.readAsDataURL(file);
    setfileNameSelected(file.name);
  }

  const handleSelectingTransFile = (event) => {
    formik.handleChange(event);
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = () => {
      const base64String = reader.result;
      //console.log(base64String);
      const ext = file.type.split('/');
      setTransferFile({ name: file.name, extension: ext[1], base64: base64String })
    };
    reader.readAsDataURL(file);
    setFileNameTrans(file.name);
  }

  const CheckboxOption = ({ children, ...props }) => (
    <components.Option {...props}>
      <div className={style.card_select_class_style}>
        <input
          type="radio"
          id={props.data.value}
          value={props.data.value}
          checked={selectedOption === props.data.value}
          onChange={handleOptionChange}
        />
        <label className={style.selec_label} htmlFor={props.data.value} onClick={() => setLabelClickSelected(props.data.value)}>
          {props.data.label}</label>
      </div>
    </components.Option>
  );
  const projectTypesSelectOption = ({ children, ...props }) => (
    <components.Option {...props}>
      <div className={style.card_select_class_style}>
        <input
          type="radio"
          id={props.data.value}
          value={props.data.value}
          checked={typeProjectOption === props.data.value}
          onChange={handleTypeProjectsOptionChange}
        />
        <label className={style.selec_label} htmlFor={props.data.value} onClick={() => setTypeProject(props.data.value)}>
          {props.data.label}</label>
      </div>
    </components.Option>
  );

  const handleOptionChange = (event) => {
    let value_selected = event.target.value;
    setSelectedOption(value_selected);
    formik.setFieldValue('documentIdType', value_selected);
    formik.setFieldValue('passportCopy', '');
    if (value_selected === 3) setDocumentSelectedValue(true);
    else setDocumentSelectedValue(false);
  };

  const handleTypeProjectsOptionChange = (event) => {
    let value_selected = event.target.value;
    setTypeProject(value_selected);
    formik.setFieldValue('projectId', value_selected);
  };
  const currentDate = () => {
    const fecha = new Date();
    const year = fecha.getFullYear();
    const month = (fecha.getMonth() + 1).toString().padStart(2, '0');
    const day = fecha.getDate().toString().padStart(2, '0');
    const hours = fecha.getHours().toString().padStart(2, '0');
    const minutes = fecha.getMinutes().toString().padStart(2, '0');
    const seconds = fecha.getSeconds().toString().padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
  const enviarDonacion = async (params) => {
    try {
      let paramstoSend = {};
      paramstoSend['projectId'] = params.projectId;
      paramstoSend['firstName'] = params.firstName;
      paramstoSend['lastName'] = null;
      paramstoSend['documentNumber'] = params.documentNumber;
      paramstoSend['prefix'] = null;
      paramstoSend['phone'] = params.phone;
      paramstoSend['email'] = params.email;
      paramstoSend['address'] = params.address;
      paramstoSend['postalCode'] = null;
      paramstoSend['city'] = 'Madrid';
      paramstoSend['country'] = params.country;
      paramstoSend['province'] = params.province;
      paramstoSend['accountNumber'] = null;
      paramstoSend['amount'] = params.otherQuantity;
      paramstoSend['type'] = 1; //Puntual
      paramstoSend['files'] = [];
      if (passportFile.length !== 0)
        paramstoSend['files'].push(passportFile)
      if (transferFile.length !== 0)
        paramstoSend['files'].push(transferFile)
      paramstoSend['dateTime'] = new Date();
      paramstoSend['periodicityType'] = 0;
      paramstoSend['documentType'] = params.documentIdType;
      let showError = false;
      if (params.documentIdType === undefined || params.documentIdType === "") {
        setShowDocumentTypeError(true);
        showError = true;
      } else {
        setShowDocumentTypeError(false);
      }
      if (params.projectId === undefined || params.projectId === "") {
        setShowProjectTypeError(true);
        showError = true;
      } else {
        setShowProjectTypeError(false);
      }
      if (showError === true) {
        return false;
      }
      else {
        return await realizarDonacion({ urlBase, params: paramstoSend });
      }
    } catch (error) {
      return { errors: error.response.data.HttpStatusCode, RemainingSeconds:error.response.data?.Attributes?.RemainingSeconds || null }
    }
  };
  const handleBlur = (e) => {
    setError();
    formik.handleBlur(e);
  };
  function clickOnSendForm() {
    if (policePrivacity === false) {
      setShowPolicePrivacityError(true);
    }else{
      setShowPolicePrivacityError(false);
    }
  }
  return (
    <form onSubmit={formik.handleSubmit} className={style.form_container_class_style}>
     
      {showThankYou && <ThankYouAlert onClose={() => setShowThankYou(false)} />}
      <div className={style.donar_div_container_element_style}>
        <label className={style.donar_title_label_style}>Quiero donar:</label>
        <span className={style.span_donation_container_style}>
          <div className={`${amountForDonation === 20 ? style.amount_donations_style : style.amount_donations_style_active}`} onClick={() => setamountForDonation(20)}><span>20€</span></div>
          <div className={`${amountForDonation === 30 ? style.amount_donations_style : style.amount_donations_style_active}`} onClick={() => setamountForDonation(30)}><span>30€</span></div>
          <div className={`${amountForDonation === 50 ? style.amount_donations_style : style.amount_donations_style_active}`} onClick={() => setamountForDonation(50)}><span>50€</span></div>
          {showHiddeOther ?
            (<div className={`${amountForDonation === 0 && formik.values.otherQuantity === '' ? style.amount_donations_style : style.amount_donations_style_active}`} onClick={() => setamountForDonation(0)}><span>Otra cantidad</span></div>
            ) : (
              <div className={style.amount_div_container_element_style}>
                <input
                  id="otherQuantity"
                  name="otherQuantity"
                  type="number"
                  className={`${style.number_amount_other_style_class} ${formik.touched.otherQuantity && formik.errors.otherQuantity ? style.amount_error_class : style.number_amount_other_style_class_with_value}`}
                  onChange={(e) => {
                    let value = parseInt(e.target.value, 10); // Convertir el valor a un número entero
                    // Verificar si el valor es un número válido y si es negativo
                    if (value < 0) {
                      value = 0; // Establecer el valor a 0 si es negativo o no es un número válido
                    }
                    formik.setFieldValue("otherQuantity", value); // Actualizar el valor del campo en el formulario
                  }}
                  onBlur={handleBlur}
                  value={formik.values.otherQuantity}
                  placeholder='Otra cantidad*'
                />
              </div>
            )}
        </span>
      </div>
      <div className={style.form_custom}>
        <div className={style.div_container_element_style}>
          <Select
            id="projectId"
            name="projectId"
            styles={(formik.values.projectId === '' || formik.values.projectId === undefined) ? styleSelect : styleSelectWithValue}
            options={typeProjectSelectOption}
            components={{ Option: projectTypesSelectOption }}
            className={[style.mi_select_style_class]}
            placeholder='Selecciona el tipo de Proyecto*'
            classNamePrefix="select"
            onChange={(option) =>
              formik.setFieldValue(
                "projectId",
                option ? option.value : "undefined"
              )
            }
            value={
              typeProjectSelectOption.find(
                (option) => option.value === formik.values.projectId
              ) || "undefined"
            }
          />
          {/*           {showProjectTypeError ? (
            <div className={style.error_style_form}>Seleccione un tipo de proyecto</div>
          ) : null} */}
          {formik.touched.projectId && formik.errors.projectId ? (
            <div className={style.error_style_form}>{formik.errors.projectId}</div>
          ) : null}
        </div>
        <div className={style.div_container_element_style}>
          <input
            id="firstName"
            name="firstName"
            type="text"
            className={`${formik.values.firstName ? style.input_custom_type_with_value : style.input_custom_type}`}
            onChange={formik.handleChange}
            onBlur={handleBlur}
            value={formik.values.firstName}
            placeholder='Nombre y apellidos o Razón Social*'
          />
          {formik.touched.firstName && formik.errors.firstName ? (
            <div className={style.error_style_form}>{formik.errors.firstName}</div>
          ) : null}
        </div>
        <div className={style.div_container_element_style}>
         
          <Select
            id="documentIdType"
            name="documentIdType"
            options={documentsOptions}
            styles={(formik.values.documentIdType === '' || formik.values.documentIdType === undefined) ? styleSelect : styleSelectWithValue}
            components={{ Option: CheckboxOption }}
            className={style.mi_select_style_class}
            placeholder='Selecciona el tipo de Documento*'
            classNamePrefix="select"
            onChange={(option) =>
              formik.setFieldValue(
                "documentIdType",
                option ? option.value : undefined
              )
            }
            value={
              documentsOptions.find(
                (option) => option.value === formik.values.documentIdType
              ) || undefined
            }
          />
          {/*           {showDocumentTypeError ? (
            <div className={style.error_style_form}>Seleccione un tipo de documento</div>
          ) : null} */}
          {formik.touched.documentIdType && formik.errors.documentIdType ? (
            <div className={style.error_style_form}>{formik.errors.documentIdType}</div>
          ) : null}
        </div>
        <div className={style.div_container_element_style}>
          <input
            id="documentNumber"
            name="documentNumber"
            type="text"
            className={`${formik.values.documentNumber ? style.input_custom_type_with_value : style.input_custom_type}`}
            onChange={formik.handleChange}
            onBlur={handleBlur}
            value={formik.values.documentNumber}
            placeholder='Nº de documento*'
          />
          {formik.touched.documentNumber && formik.errors.documentNumber ? (
            <div className={style.error_style_form}>{formik.errors.documentNumber}</div>
          ) : null}
        </div>
        {documentSelectedValue ? <>
          <div className={style.div_container_element_style}>
            <input
              id="prefix"
              name="prefix"
              type="text"
              className={`${formik.values.prefix ? style.input_custom_type_with_value : style.input_custom_type}`}
              onChange={formik.handleChange}
              onBlur={handleBlur}
              value={formik.values.prefix}
              placeholder='Nacionalidad*'
            />
            {formik.touched.prefix && formik.errors.prefix ? (
              <div className={style.error_style_form}>{formik.errors.prefix}</div>
            ) : null}
          </div>
          <div className={style.div_container_element_style}>
            <div className={`${fileNameSelected === 'Copia del pasaporte*' ? style.file_upload_design_style_class : style.file_upload_design_style_class_with_value}`}>
              <p className={`${fileNameSelected === 'Copia del pasaporte*' ? style.passport_name_style : style.passport_name_style_with_value}`}>{fileNameSelected}</p>
              <div className={style.passport_click_container}>
                <label>Adjuntar Archivo</label>
                <svg width="7" height="16" viewBox="0 0 7 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clipPath="url(#clip0_11_2701)">
                    <path d="M3.76577 0.1651C2.90827 0.166079 2.08618 0.507154 1.47983 1.1135C0.873489 1.71984 0.532414 2.54194 0.531435 3.39944V13.4096C0.52747 13.7306 0.587282 14.0493 0.707404 14.3471C0.827526 14.6448 1.00557 14.9158 1.2312 15.1442C1.45684 15.3727 1.72558 15.554 2.02185 15.6778C2.31811 15.8016 2.63601 15.8654 2.95709 15.8654C3.27818 15.8654 3.59608 15.8016 3.89234 15.6778C4.18861 15.554 4.45735 15.3727 4.68299 15.1442C4.90862 14.9158 5.08666 14.6448 5.20679 14.3471C5.32691 14.0493 5.38672 13.7306 5.38275 13.4096V3.39944C5.38275 2.97059 5.21239 2.5593 4.90915 2.25606C4.60591 1.95281 4.19462 1.78245 3.76577 1.78245C3.33692 1.78245 2.92563 1.95281 2.62239 2.25606C2.31915 2.5593 2.14879 2.97059 2.14879 3.39944V12.1966C2.14715 12.2508 2.15639 12.3046 2.17597 12.3551C2.19555 12.4056 2.22507 12.4516 2.26277 12.4905C2.30046 12.5293 2.34558 12.5602 2.39544 12.5813C2.4453 12.6024 2.49889 12.6133 2.55303 12.6133C2.60717 12.6133 2.66076 12.6024 2.71062 12.5813C2.76048 12.5602 2.8056 12.5293 2.8433 12.4905C2.881 12.4516 2.91051 12.4056 2.93009 12.3551C2.94967 12.3046 2.95892 12.2508 2.95728 12.1966V3.39944C2.95728 3.18501 3.04246 2.97937 3.19408 2.82775C3.3457 2.67612 3.55135 2.59094 3.76577 2.59094C3.9802 2.59094 4.18584 2.67612 4.33746 2.82775C4.48908 2.97937 4.57426 3.18501 4.57426 3.39944V13.4096C4.56784 13.8342 4.39463 14.2393 4.09205 14.5374C3.78947 14.8354 3.38181 15.0024 2.95709 15.0024C2.53238 15.0024 2.12471 14.8354 1.82213 14.5374C1.51956 14.2393 1.34635 13.8342 1.33993 13.4096V3.39944C1.33993 2.75606 1.59551 2.13904 2.05044 1.68411C2.50537 1.22917 3.1224 0.973592 3.76577 0.973592C4.40914 0.973592 5.02617 1.22917 5.4811 1.68411C5.93604 2.13904 6.19162 2.75606 6.19162 3.39944V12.1966C6.18998 12.2508 6.19922 12.3046 6.2188 12.3551C6.23838 12.4056 6.26789 12.4516 6.30559 12.4905C6.34329 12.5293 6.38841 12.5602 6.43827 12.5813C6.48813 12.6024 6.54172 12.6133 6.59586 12.6133C6.65 12.6133 6.70359 12.6024 6.75345 12.5813C6.80331 12.5602 6.84843 12.5293 6.88613 12.4905C6.92383 12.4516 6.95334 12.4056 6.97292 12.3551C6.9925 12.3046 7.00174 12.2508 7.00011 12.1966V3.39944C6.99913 2.54194 6.65805 1.71984 6.05171 1.1135C5.44537 0.507154 4.62327 0.166079 3.76577 0.1651Z" fill="#00499A" />
                  </g>
                  <defs>
                    <clipPath id="clip0_11_2701">
                      <rect width="6.46867" height="15.6699" fill="white" transform="translate(0.53125 0.165039)" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </div>
            <input
              id="passportCopy"
              name="passportCopy"
              type="file"
              className={`${style.input_custom_type} ${style.file_upload_style}`}
              onChange={handleSelectingFile}
              onBlur={handleBlur}
              value={formik.values.passportCopy}
              placeholder='Copia del pasaporte*'
            />
            {formik.touched.passportCopy && formik.errors.passportCopy ? (
              <div className={style.error_style_form_passport}>{formik.errors.passportCopy}</div>
            ) : null}
          </div>
        </> : ''}
        <div className={`${style.div_container_element_style} ${documentSelectedValue ? style.movil_view_conditional : ''}`}>
          <input
            id="address"
            name="address"
            type="text"
            className={`${formik.values.address ? style.input_custom_type_with_value : style.input_custom_type}`}
            onChange={formik.handleChange}
            onBlur={handleBlur}
            value={formik.values.address}
            placeholder='Domicilio Fiscal*'
          />
          {formik.touched.address && formik.errors.address ? (
            <div className={style.error_style_form}>{formik.errors.address}</div>
          ) : null}
        </div>
        <div className={style.div_container_element_style}>
          <input
            id="province"
            name="province"
            type="text"
            className={`${formik.values.province ? style.input_custom_type_with_value : style.input_custom_type}`}
            onChange={formik.handleChange}
            onBlur={handleBlur}
            value={formik.values.province}
            placeholder='Provincia*'
          />
          {formik.touched.province && formik.errors.province ? (
            <div className={style.error_style_form}>{formik.errors.province}</div>
          ) : null}
        </div>
        <div className={style.div_container_element_style}>
          <input
            id="country"
            name="country"
            type="text"
            className={`${formik.values.country ? style.input_custom_type_with_value : style.input_custom_type}`}
            onChange={formik.handleChange}
            onBlur={handleBlur}
            value={formik.values.country}
            placeholder='País*'
          />
          {formik.touched.country && formik.errors.country ? (
            <div className={style.error_style_form}>{formik.errors.country}</div>
          ) : null}
        </div>
        <div className={style.div_container_element_style}>
          <input
            id="email"
            name="email"
            type="email"
            className={`${formik.values.email ? style.input_custom_type_with_value : style.input_custom_type}`}
            onChange={formik.handleChange}
            onBlur={handleBlur}
            value={formik.values.email}
            placeholder='Email*'
          />
          {formik.touched.email && formik.errors.email ? (
            <div className={style.error_style_form}>{formik.errors.email}</div>
          ) : null}
        </div>
        <div className={style.div_container_element_style}>
          <input
            id="phone"
            name="phone"
            type="text"
            className={`${formik.values.phone ? style.input_custom_type_with_value : style.input_custom_type}`}
            onChange={formik.handleChange}
            onBlur={handleBlur}
            value={formik.values.phone}
            placeholder='Teléfono*'
          />
          {formik.touched.phone && formik.errors.phone ? (
            <div className={style.error_style_form}>{formik.errors.phone}</div>
          ) : null}
        </div>
        <div className={style.div_container_element_style}>
          <div className={`${fileNameTrans === 'Comprobante transferencia*' ? style.file_upload_design_style_class : style.file_upload_design_style_class_with_value}`}>
            <p className={`${fileNameTrans === 'Comprobante transferencia*' ? style.passport_name_style : style.passport_name_style_with_value}`}>{fileNameTrans}</p>
            <div className={style.passport_click_container}>
              <label>Adjuntar Archivo</label>
              <svg width="7" height="16" viewBox="0 0 7 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_11_2701)">
                  <path d="M3.76577 0.1651C2.90827 0.166079 2.08618 0.507154 1.47983 1.1135C0.873489 1.71984 0.532414 2.54194 0.531435 3.39944V13.4096C0.52747 13.7306 0.587282 14.0493 0.707404 14.3471C0.827526 14.6448 1.00557 14.9158 1.2312 15.1442C1.45684 15.3727 1.72558 15.554 2.02185 15.6778C2.31811 15.8016 2.63601 15.8654 2.95709 15.8654C3.27818 15.8654 3.59608 15.8016 3.89234 15.6778C4.18861 15.554 4.45735 15.3727 4.68299 15.1442C4.90862 14.9158 5.08666 14.6448 5.20679 14.3471C5.32691 14.0493 5.38672 13.7306 5.38275 13.4096V3.39944C5.38275 2.97059 5.21239 2.5593 4.90915 2.25606C4.60591 1.95281 4.19462 1.78245 3.76577 1.78245C3.33692 1.78245 2.92563 1.95281 2.62239 2.25606C2.31915 2.5593 2.14879 2.97059 2.14879 3.39944V12.1966C2.14715 12.2508 2.15639 12.3046 2.17597 12.3551C2.19555 12.4056 2.22507 12.4516 2.26277 12.4905C2.30046 12.5293 2.34558 12.5602 2.39544 12.5813C2.4453 12.6024 2.49889 12.6133 2.55303 12.6133C2.60717 12.6133 2.66076 12.6024 2.71062 12.5813C2.76048 12.5602 2.8056 12.5293 2.8433 12.4905C2.881 12.4516 2.91051 12.4056 2.93009 12.3551C2.94967 12.3046 2.95892 12.2508 2.95728 12.1966V3.39944C2.95728 3.18501 3.04246 2.97937 3.19408 2.82775C3.3457 2.67612 3.55135 2.59094 3.76577 2.59094C3.9802 2.59094 4.18584 2.67612 4.33746 2.82775C4.48908 2.97937 4.57426 3.18501 4.57426 3.39944V13.4096C4.56784 13.8342 4.39463 14.2393 4.09205 14.5374C3.78947 14.8354 3.38181 15.0024 2.95709 15.0024C2.53238 15.0024 2.12471 14.8354 1.82213 14.5374C1.51956 14.2393 1.34635 13.8342 1.33993 13.4096V3.39944C1.33993 2.75606 1.59551 2.13904 2.05044 1.68411C2.50537 1.22917 3.1224 0.973592 3.76577 0.973592C4.40914 0.973592 5.02617 1.22917 5.4811 1.68411C5.93604 2.13904 6.19162 2.75606 6.19162 3.39944V12.1966C6.18998 12.2508 6.19922 12.3046 6.2188 12.3551C6.23838 12.4056 6.26789 12.4516 6.30559 12.4905C6.34329 12.5293 6.38841 12.5602 6.43827 12.5813C6.48813 12.6024 6.54172 12.6133 6.59586 12.6133C6.65 12.6133 6.70359 12.6024 6.75345 12.5813C6.80331 12.5602 6.84843 12.5293 6.88613 12.4905C6.92383 12.4516 6.95334 12.4056 6.97292 12.3551C6.9925 12.3046 7.00174 12.2508 7.00011 12.1966V3.39944C6.99913 2.54194 6.65805 1.71984 6.05171 1.1135C5.44537 0.507154 4.62327 0.166079 3.76577 0.1651Z" fill="#00499A" />
                </g>
                <defs>
                  <clipPath id="clip0_11_2701">
                    <rect width="6.46867" height="15.6699" fill="white" transform="translate(0.53125 0.165039)" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
          <input
            id="transferChecked"
            name="transferChecked"
            type="file"
            className={`${style.input_custom_type} ${style.file_upload_style}`}
            onChange={handleSelectingTransFile}
            onBlur={handleBlur}
            value={formik.values.transferChecked}
            placeholder='Comprobante transferencia*'
          />
          {formik.touched.transferChecked && formik.errors.transferChecked ? (
            <div className={style.error_style_form_passport}>{formik.errors.transferChecked}</div>
          ) : null}
        </div>
        <div className={`${style.div_container_element_style} ${style.change_order_view_5}`}>
          <label className={style.policy_acept_container}>
            <input
              className={style.input_custom}
              type='checkbox'
              checked={policePrivacity}
              onChange={() => setPolicePrivacity(!policePrivacity)}
            />
            <span className={style.checkbox_container}></span>
            <p style={{ marginLeft: '10px' }}>He leído y acepto la <a target="_blank" href='https://www.fundacionbavieraresponsable.org/politica-privacidad/'>Política de Privacidad</a></p>
          </label>
          {policePrivacity === false && showPolicePrivacityError === true ? (
            <div className={style.error_style_form}>Debes aceptar los términos y condiciones</div>
          ) : null}
        </div>

        <div className={`${style.div_container_element_style} ${style.movil_view_conditional} ${style.change_order_view_4}`}>
          <p className={`${style.p_general} ${style.p_general_info}`}>*Puedes hacer tu donación a este Nº Cuenta:</p>
          <p className={`${style.p_general} ${style.p_general_cuenta}`}>ES50 2100 8660 6902 0009 8380</p>
        </div>
      </div>
      <div className={style.send_btn_style}>
        {error && <p style={{ color: "red" }}>{error}</p>}

        <button disabled={loading} className={style.button_send} type="submit" onClick={clickOnSendForm}>{!loading ? 'Enviar' : 'Enviando formulario...'}</button>

      </div>
    </form>
  );
}
